import React, { useEffect, useState } from 'react';
import * as general from '../../libs/general';
import { MEDAL_TIERS, decomposeRank, fetchRankDiscountSetting } from '../../libs/rankMedals';

const formatPercent = (value) => {
  const num = Number(value) || 0;
  return `${Math.round(num * 100) / 100}%`;
};

const useRankDiscountSetting = () => {
  const [setting, setSetting] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetchRankDiscountSetting().then((data) => {
      if (!cancelled) setSetting(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return setting;
};

const MedalRow = ({ tier, count }) => (
  <span className="d-inline-flex align-items-center gap-1" title={`Huy chương ${tier.label}`}>
    <span className="medal-line">
      {[...Array(count)].map((_, index) => (
        <span key={index} className={`medal ${tier.className}`}></span>
      ))}
    </span>
  </span>
);

/**
 * Số huy chương + % chiết khấu rank của một đơn.
 * rankDiscountPercent null = đơn tính theo logic rank cũ (nội suy bảng giá), không có % theo huy chương.
 */
export const RankDiscountDetails = ({ rank, rankDiscountPercent, feeOriginal, fee, compact = false }) => {
  const setting = useRankDiscountSetting();
  const medals = decomposeRank(rank);
  const tiers = MEDAL_TIERS.filter((tier) => medals[tier.key] > 0).reverse();
  const isLegacy = rankDiscountPercent === null || rankDiscountPercent === undefined;

  return (
    <div className="small d-flex justify-content-between" style={{ lineHeight: 1.6 }}>
      <div>
        <div className="fw-bold">Thành tích:</div>
        {tiers.map((tier) => {
          return (
            <span key={tier.key}>
              <MedalRow tier={tier} count={medals[tier.key]} />
            </span>
          );
        })}
      </div>
      


      <div>
        {isLegacy ? (
          <div className="text-muted">Đơn tính theo bảng giá rank cũ</div>
        ) : (
          <div className="fw-bold text-success">Chiết khấu cước kg/m3: {formatPercent(rankDiscountPercent)}</div>
        )}
        {!compact && feeOriginal !== null && feeOriginal !== undefined && (
          <>
            <div>
              Gốc: {general.formatNumber(feeOriginal) || 0} → Sau CK: {general.formatNumber(fee) || 0} vnđ
            </div>
            <div className="fw-bold text-danger">
              Số tiền chiết khấu: {general.formatNumber(Math.max(0, (Number(feeOriginal) || 0) - (Number(fee) || 0))) || 0} vnđ
            </div>
          </>
        )}
      </div>
      
    </div>
  );
};

/** Bọc số tiền đối soát KH; hover hiện panel huy chương + % chiết khấu của đơn. */
export const RankDiscountHover = ({ rank, rankDiscountPercent, feeOriginal, fee, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <span
      className="position-relative d-inline-block"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{ cursor: 'help' }}
    >
      {children}
      {open && (
        <span
          className="position-absolute bg-white border rounded shadow-sm p-2 text-start"
          style={{ zIndex: 1050, top: '100%', left: '50%', transform: 'translateX(-50%)', minWidth: '230px', whiteSpace: 'normal' }}
        >
          <RankDiscountDetails rank={rank} rankDiscountPercent={rankDiscountPercent} feeOriginal={feeOriginal} fee={fee} />
        </span>
      )}
    </span>
  );
};
